import ApiErrorResponse from "@eryxcoop/appyx-comm/src/responses/generalResponses/ApiErrorResponse";

export default class ExpiredActionRequestOfAuthorizationErrorResponse extends ApiErrorResponse {
    static defaultResponse() {
        return {
            object: {
            },
            errors: [{
                'code': 'expired_action_request',
                'text': 'Action request for authorizations have expired',
            }]
        }
    }

    static errorCodes() {
        return ['expired_action_request'];
    }
}